"use strict";
exports.__esModule = true;
exports.locationPath = void 0;
var currLocation_1 = require("./currLocation");
// ----------- set Functions
var locationPath = function () { return (0, currLocation_1.currLocation)().pathname.split('/')[1]; };
exports.locationPath = locationPath;
